<div class="container-fluid p-0">
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <span class="navbar-brand">Account Access</span>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#accountAccessNav" aria-controls="accountAccessNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="accountAccessNav">
      <span class="mr-auto">
        <!--
          A page-level action, not a per-row one. It applies to the user rather than to any one request, so
          repeating it on every row (as the previous card layout did) implied it was scoped to that account
          and produced an identical copy per request.

          There is deliberately no "Continue to My Account" button beside it. This page is not a blocking
          interstitial: the full left navigation is available, so leaving is already a click away and a
          dedicated button only restated what the Dashboard link already does.
        -->
        <button mat-raised-button color="primary" class="m-1 mr-2" (click)="onChooseDifferentEmployer()"
                matTooltip="Search for a different employer and ask to join them instead.">
          <mat-icon>business</mat-icon>
          Choose a Different Employer
        </button>
      </span>
    </div>
  </nav>

  <div class="d-flex justify-content-center p-4" *ngIf="inProgress && !requests.length">
    <mat-progress-spinner [mode]="'indeterminate'" diameter="32"></mat-progress-spinner>
  </div>

  <!--
    Said once above the list rather than repeated in every row. The previous layout restated the same
    explanation per request, which drowned the actual information (which account, when, what state).
  -->
  <div class="alert alert-info m-2" *ngIf="!inProgress && requests.length">
    <mat-icon class="align-middle mr-2">info</mat-icon>
    An administrator at each company has to approve your request before you can see their information. They
    have been notified. While you wait you can keep working in your own account, complete any inductions
    assigned to you, and sign in to sites as usual.
  </div>

  <div class="alert alert-info m-2" *ngIf="!inProgress && !requests.length">
    <mat-icon class="align-middle mr-2">info</mat-icon>
    You have no outstanding requests to join a company account. You are working in your own account. Use
    <b>Choose a Different Employer</b> above to ask to join one.
  </div>

  <div class="mat-elevation-z8 scroll-box m-2" *ngIf="requests.length">
    <table mat-table [dataSource]="requests">

      <ng-container matColumnDef="account_name">
        <th mat-header-cell *matHeaderCellDef>Company</th>
        <td mat-cell *matCellDef="let request">
          <b>{{ request.account_name }}</b>
        </td>
      </ng-container>

      <ng-container matColumnDef="requested_at">
        <th mat-header-cell *matHeaderCellDef>Requested</th>
        <td mat-cell *matCellDef="let request">
          {{ request.requested_at ? ((request.requested_at * 1000) | timezoneConvertMedium) : 'Not recorded' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let request">
          <span class="status-chip" [ngClass]="'status-chip-' + (request.approval_status || 'pending')">
            {{ request.approval_status === 'declined' ? 'Not Approved' : 'Awaiting Approval' }}
          </span>

          <!-- Their own message, played back to them. Two things need confirming after asking again: that
               something was actually sent, and what it said. Without this the user has no record of it and
               risks repeating themselves if they end up asking a final time. -->
          @if(request.request_reason) {
            <small class="d-block text-muted mt-1">
              Your message: {{ request.request_reason }}
            </small>
          }

          <!-- Only a refusal carries detail worth showing, and it is the detail the user needs in order
               to decide what to do next. -->
          @if(request.approval_status === 'declined') {
            @if(request.decline_reason) {
              <small class="d-block text-muted mt-1">Reason: {{ request.decline_reason }}</small>
            } @else {
              <small class="d-block text-muted mt-1">No reason was given.</small>
            }

            @if(!request.can_request_again) {
              <small class="d-block text-muted mt-1">
                You have reached the limit for asking to join this company. They can still approve your
                existing request, so contact them directly if you think this was a mistake.
              </small>
            }
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="200"></th>
        <td mat-cell *matCellDef="let request">
          <!-- Per row, because these DO apply to one specific request. -->
          <button mat-button *ngIf="request.approval_status === 'pending'" (click)="onCancel(request)"
                  matTooltip="Withdraw this request. You can ask again afterwards.">
            Cancel Request
          </button>

          <button mat-button *ngIf="request.approval_status === 'declined' && request.can_request_again"
                  [disabled]="inProgress" (click)="onRequestAgain(request)"
                  matTooltip="Ask {{ request.account_name }} to reconsider.">
            Request Again
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>
